if (!customElements.get('sticky-addcart')) {
  customElements.define(
    'sticky-addcart',
    class StickyAddcart extends HTMLElement {
      constructor() {
        super()
        this.addToCartButton = document.getElementById(this.dataset.button)

        if (this.addToCartButton) {
          let observer = new IntersectionObserver(function (entries) {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                document.body.classList.remove('with-sticky-addcart')
              } else {
                let { bottom } = entry.boundingClientRect
                let { top } = entry.intersectionRect

                document.body.classList.toggle(
                  'with-sticky-addcart',
                  bottom < top
                )
              }
            })
          }, { threshold: 0.1 })

          observer.observe(this.addToCartButton)
        }
      }
    }
  )
}